export default __webpack_public_path__ + "static/media/screen_facebook_4.5298c7df.png";